import { rest } from 'msw'

import { CardApiModelStub } from '@webapp/modules/spending-cards/data-access/api-models/stubs/CardApiModel.stub'
import { getResponseObject } from '@webapp/tests'

export const mockGetRequestableCardsSuccess = (
  cardStubs = CardApiModelStub.buildList(1)
) => {
  return rest.get(`/api/v3/pay/cards/requestable/`, (_, res, ctx) => {
    return res.once(ctx.status(200), ctx.json(getResponseObject(cardStubs)))
  })
}

export const mockGetRequestableCardsError = () => {
  return rest.get(`/api/v3/pay/cards/requestable/`, (_, res, ctx) => {
    return res.once(ctx.status(400))
  })
}
